// src/services/trilhaServices.js
import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useTrilhaService() {
  const { authenticatedFetch, authenticatedFormFetch } = useApi();

  /**
   * criarTrilha
   * Espera um FormData já montado na página.
   * O FormData é passado como segundo argumento do authenticatedFormFetch.
   */
  const criarTrilha = async (formData) => {
    const response = await authenticatedFormFetch(URLS.CREATE_TRILHA, formData);
    return response.json();
  };

  /**
   * atualizarTrilha
   * ATENÇÃO: isso aqui só vai funcionar se o endpoint de update também
   * tiver sido adaptado para multipart/form-data.
   * Se o seu trilhaUpdate.php ainda espera JSON, mantenha esse método com authenticatedFetch + JSON.
   */
  const atualizarTrilha = async (formData) => {
    const response = await authenticatedFormFetch(URLS.UPDATE_TRILHA, formData);
    return response.json();
  };

  const deletarTrilha = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_TRILHA, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarTrilhas = async () => {
    const response = await authenticatedFetch(URLS.GET_TRILHAS, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    return response.json();
  };

  /**
   * obterTrilhaPorId
   * Agora usa POST com JSON no corpo:
   * { "id": "<id ou hash>" }
   */
  const obterTrilhaPorId = async (id) => {
    const response = await authenticatedFetch(URLS.GET_TRILHA_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarTrilhasComCertificado = async () => {
    const response = await authenticatedFetch(URLS.GET_TRILHAS_COM_CERTIFICADO, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    return response.json();
  };

  return {
    criarTrilha,
    atualizarTrilha,
    deletarTrilha,
    listarTrilhas,
    obterTrilhaPorId,
    listarTrilhasComCertificado,
  };
}